module.exports = __webpack_public_path__ + "img/enteringCode3.065e7843.jpg";